import React from "react";
import '../style/Terms.css';
import { t } from "i18next";

const Terms = () => (
    <main className="about_content">
        <div className="content">
            <h1 className="m_0">{t('termsOfUse')}</h1>
        </div>
        <div className="content">
            <section className="terms-section">
                <h2>{t('payments')}</h2>
                <p>{t('paymentDescription1')}</p>
                <p>{t('paymentDescription2')}</p>
                <p>{t('paymentDescription3')}</p>
            </section>

            <section className="terms-section">
                <h2>{t('securityGuarantees')}</h2>
                <p>{t('securityDescription1')}</p>
            </section>

            <section className="terms-section">
                <h2>{t('onlinePaymentSecurity')}</h2>
                <p>{t('securityDescription2')}</p>
                <p>{t('securityDescription3')}</p>
            </section>

            <section className="terms-section">
                <h2>{t('refunds')}</h2>
                <p>{t('refundDescription1')}</p>
                <p>{t('refundDescription2')}</p>
                <p>{t('refundDescription3')}</p>
            </section>

            <section className="terms-section">
                <h2>{t('paymentFailureCases')}</h2>
                <ul>
                    <li>{t('paymentFailure1')}</li>
                    <li>{t('paymentFailure2')}</li>
                    <li>{t('paymentFailure3')}</li>
                    <li>{t('paymentFailure4')}</li>
                </ul>
                <p>{t('paymentFailureAdvice')}</p>
            </section>

            <section className="terms-section">
                <h2>{t('privacy')}</h2>
                <p>{t('privacyDescription1')}</p>
                <p>{t('privacyDescription2')}</p>
            </section>

            <section className="terms-section">
                <h2>{t('limitationOfLiability')}</h2>
                <p>{t('limitationDescription')}</p>
            </section>

            <section className="terms-section">
                <h2>{t('contacts')}</h2>
                <p>{t('contactDescription')}</p>
            </section>
        </div>
    </main>
);

export default Terms;